import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import { MainContent } from '../../../components/MainContent'
import { Recap } from '../../../containers/cestovko/Recap'
import { meetingRecordContext } from '../../carkulka/wizard/5'
import { useGetMeetingRecord } from '../../../hooks/useWizard'
import { useContext, useEffect } from 'react'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { MeetingRecordFormTravel } from '../../../containers/MeetingRecordFormTravel'
import { CompletedPage } from './completed'
import { Loading } from '../../../components/Loading'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { WithOffer } from '../../../containers/hoc/WithOffer'

export const _Step5 = () => {
  const { insuranceParams, insuranceParamsId, isLoadingData } = useContext(insuranceParamsContext)
  const { isLoading, isFetching, data, refetch } = useGetMeetingRecord(insuranceParamsId!, { enabled: false, cacheTime: 0 })
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  // vynuceni nacteni dat
  useEffect(() => {
    if (!!insuranceParamsId) {
      refetch()
    }
  }, [insuranceParamsId])

  return (
    <Section>
      <Container>
        <meetingRecordContext.Provider
          value={{
            isLoading: isFetching || isLoading,
            refetch: refetch,
            meetingRecord: data?.data
          }}>

          {isLoadingData && <Loading large={true} />}

          {!isContracted && !!insuranceParams &&
            <StepsContent step={5} >
              <Steps icon="beach" />

              <InsuranceInfo />

              <MainContent>
                <Recap />

                <MeetingRecordFormTravel />
              </MainContent>

            </StepsContent>
          }

          {isContracted && !!insuranceParams && <CompletedPage />}
        </meetingRecordContext.Provider>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step5 = WithOffer(WithAuth(_Step5))